import EFOcats_event_box_change from './efocats_event_box_change.js';
import EFOcats_event_input from './efocats_event_input.js';
import EFOcats_event_page from './efocats_event_page.js';
import EFOcats_event_postno from './efocats_event_postno.js';
import EFOcats_event_submit from './efocats_event_submit.js';
import EFOcats_event_before_leave from './efocats_event_before_leave.js';
import EFOcats_event_leave from './efocats_event_leave.js';
import EFOcats_event_birthday from './efocats_event_birthday.js';
import EFOcats_event_date from './efocats_event_date.js';
import EFOcats_event_tab from './efocats_event_tab.js';

/**
 * イベントクラス
 */
export default class EFOcats_event {
  constructor() {
    this.box_change = new EFOcats_event_box_change();
    this.input = new EFOcats_event_input();
    this.page = new EFOcats_event_page();
    this.postno = new EFOcats_event_postno();
    this.submit = new EFOcats_event_submit();
    this.before_leave = new EFOcats_event_before_leave();
    this.leave = new EFOcats_event_leave();
    this.birthday = new EFOcats_event_birthday();
    this.date = new EFOcats_event_date();
    this.tab = new EFOcats_event_tab();
  }

  /**
   * 各種イベントを設置する
   */
  initialize() {
    Object.keys(this).forEach(key => {
      if (this[key]) {
        this[key].init();
        this[key].event();
      }
    });
  }
}
